import React, { memo } from "react";
import { Divider } from "@chakra-ui/react";
import { PresentationSummary } from "./PresentationSummary";
import { ParticipantFullSummary } from "../../types/participant.types";
import { RegistrationRequest } from "../../types/registration.types";
import { ConferenceConfiguration } from "../../types/conference.types";
import type { PresentationSummary as PresentationSummaryModel } from "../../types/presentation.types";
import type { ParticipantSummaryChanges } from "./participantSummarySectionTypes";

export interface ParticipantSummaryPresentationSectionProps {
  registrationId: number;
  participant: ParticipantFullSummary;
  modifiedData: RegistrationRequest | null | undefined;
  displayConfigJson: ConferenceConfiguration;
  changes: ParticipantSummaryChanges;
  modifiedPresentations: PresentationSummaryModel[] | null;
}

const ParticipantSummaryPresentationSectionInner: React.FC<
  ParticipantSummaryPresentationSectionProps
> = ({
  registrationId,
  participant,
  modifiedData,
  displayConfigJson,
  changes,
  modifiedPresentations,
}) => {
  const registrationConfigJson = participant.congressEvent.configJson;

  const hasModifiedPresentationData =
    modifiedData?.presentations != null &&
    modifiedData.presentations.length > 0 &&
    modifiedData.presentations.some(
      (p) =>
        !!(
          (p.presentationTypeId && p.presentationTypeId !== 0) ||
          (p.presentationTopicId && p.presentationTopicId !== 0) ||
          p.presentationTitle?.trim() ||
          p.performers?.trim() ||
          p.performersWorkplace?.trim()
        ),
    );

  const showPresentationSection =
    (participant.presentations && participant.presentations.length > 0) ||
    (registrationConfigJson?.presentationEnabled && !modifiedData) ||
    (!!modifiedData &&
      displayConfigJson.presentationEnabled &&
      hasModifiedPresentationData);

  if (!showPresentationSection) return null;

  const presentationContent =
    changes["presentations"] !== undefined && modifiedPresentations ? (
      <PresentationSummary
        participantId={registrationId}
        presentations={modifiedPresentations}
        originalPresentations={participant.presentations || null}
      />
    ) : (
      <PresentationSummary
        participantId={registrationId}
        presentations={
          modifiedPresentations || participant.presentations || []
        }
      />
    );

  return (
    <>
      {presentationContent}
      <Divider />
    </>
  );
};

export const ParticipantSummaryPresentationSection = memo(
  ParticipantSummaryPresentationSectionInner,
);
